import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import _isEqual from 'lodash/isEqual';

import { useFeatures } from '@atc/features';

import { Col } from 'reaxl';
import { InventoryListingPlaceholder, InventoryListingV2 } from 'reaxl-listing';

import useInventoryListingProps from '@/utilities/useInventoryListingProps';

import srpResultsDuck from '@/ducks/srp/srpResultsDuck.js';

import useEsntialEligibility from '@/hooks/useEsntialEligibility';

function InventoryListingContainer({ listing, index, paginatedListingIndex }) {

    const getListingProps = useInventoryListingProps();
    const {
        accelerate: [, {
            enable_listing_badge: enableListingBadge,
        }],
        srp_hero: [, {
            cmp: buyOnlineCmp,
        }],
    } = useFeatures([
        'accelerate',
        'srp_hero',
    ]);

    const isResultsLoading = useSelector(srpResultsDuck.selectors.getResultLoading);
    const isSponsoredExperience = buyOnlineCmp === 'hyundai-buy-online';

    // Use custom hook for eligibility check (hook handles sponsored experience condition internally)
    useEsntialEligibility(listing, isSponsoredExperience);

    if (!enableListingBadge) {
        listing.accelerate = false;
    }

    if (isResultsLoading) {
        return (
            <Col
                xs={12}
                sm={6}
                md={4}
            >
                <InventoryListingPlaceholder
                    data-cmp="inv-placeholder-lstg"
                    key={`inventory-placeholder-${index}`}
                />
            </Col>

        );
    }

    return (
        <Col
            xs={12}
            sm={6}
            md={4}
            className="display-flex"
            key={`listing-${index}`}
        >
            <InventoryListingV2 {...getListingProps('listings', listing, index, paginatedListingIndex)} />
        </Col>
    );

}

export default memo(InventoryListingContainer, _isEqual);
